// extracted by mini-css-extract-plugin
export var container = "container-center-module--container--JFVyT";